import { render, staticRenderFns } from "./LoanHistory.vue?vue&type=template&id=5e797b3e&scoped=true&"
import script from "./LoanHistory.vue?vue&type=script&lang=js&"
export * from "./LoanHistory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e797b3e",
  null
  
)

export default component.exports